<template>
  <ExternalList
      headline="Contacts"
      endpoint="/api/v2/contacts"
      :endpoint-filters="{portal_company_id: portalCompany.id}"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-update="() => true"
      :can-destroy="() => true"
      @show="contact => $router.push(getUrl(contact))"
  >
    <template v-slot:default="{ row: contact }">
      <td>
        <router-link :to="getUrl(contact)">
          {{ contact.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ contact.attributes.title }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link class="btn btn-white btn-sm" style="margin-top: 4px;" to="contacts/create">
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {ExternalList},

  props: {
    portalCompany: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Title'},
      ]
    }
  },

  methods: {
    getUrl(contact) {
      return '/companies/' + this.portalCompany.attributes.company_id + '/portals/' + this.portalCompany.id + '/contacts/' + contact.id + '/edit'
    }
  }
}
</script>
